import { render, staticRenderFns } from "./OrderablePreviewSummary.vue?vue&type=template&id=dbd177be&"
import script from "./OrderablePreviewSummary.vue?vue&type=script&lang=ts&"
export * from "./OrderablePreviewSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports